// src/pages/faq/redux/faqCategorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getActiveFaqCategories } from '../../../services/Faq/FaqCategoryService';

// Thunk to fetch FAQ categories
export const fetchFaqCategories = createAsyncThunk(
  'faqCategories/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const result = await getActiveFaqCategories();

      if (result.response_code === 1 && Array.isArray(result.data)) {
        return result.data.map((cat) => ({
          label: cat.name,
          value: cat.id,
        }));
      } else {
        return rejectWithValue('Invalid response format');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch categories');
    }
  }
);

const faqCategorySlice = createSlice({
  name: 'faqCategories',
  initialState: {
    categories: [],
    status: 'idle', 
    error: null,
  },
  reducers: {
    clearFaqCategories(state) {
      state.categories = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFaqCategories.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchFaqCategories.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.categories = action.payload;
      })
      .addCase(fetchFaqCategories.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearFaqCategories } = faqCategorySlice.actions;

export default faqCategorySlice.reducer;
